export default __webpack_public_path__ + "static/media/forward.722d9800.svg";